import { recordPath, recordRoute } from '@/shared/registry'

/** Where the badge pages live. */
export const badgesPath = '/credentials/badges'
export const createBadgePath = `${badgesPath}/new`
export const badgeRoute = recordRoute('credentials', 'badges')
export const editBadgeRoute = `${badgeRoute}/edit`

/** A badge's details page. */
export function badgePath(id: string): string {
  return recordPath('credentials', 'badges', id)
}

/** The base of Badge Details' slots (`detailsSlots`). */
export const badgeDetailsSlot = 'credentials.badge-details'

/** The permissions the badge screens show or hide their actions by. */
export const readBadgesPermission = 'credentials.badges.read'
export const writeBadgesPermission = 'credentials.badges.write'
export const deleteBadgesPermission = 'credentials.badges.delete'

/** The API's badge endpoints. */
export const badgesApi = '/credentials/v1/badges'

export function badgeApi(id: string): string {
  return `${badgesApi}/${encodeURIComponent(id)}`
}
